import { render } from "./FourthCut.vue?vue&type=template&id=1346321f&scoped=true"
import script from "./FourthCut.vue?vue&type=script&lang=js"
export * from "./FourthCut.vue?vue&type=script&lang=js"

import "./FourthCut.vue?vue&type=style&index=0&id=1346321f&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1346321f"]])

export default __exports__